// src/components/ConsentGate.js
// src/components/ConsentGate.js
import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth, db } from "../firebase";
import { doc, getDoc, setDoc, serverTimestamp } from "firebase/firestore";

export default function ConsentGate({ children }) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        // Not signed in; let router guards handle redirect logic
        setReady(true);
        return;
      }

      const ref = doc(db, "users", user.uid, "meta", "consent");

      try {
        const snap = await getDoc(ref);

        if (!snap.exists()) {
          // Option A: create a default doc so the page never blanks
          await setDoc(ref, { consent: false, createdAt: serverTimestamp() });
          console.log("[ConsentGate] Created default consent doc");
        } else {
          console.log("[ConsentGate] Consent doc:", snap.data());
        }
      } catch (e) {
        console.error("[ConsentGate] Firestore error:", e);
        // Even if there’s an error, don’t blank the UI
      } finally {
        setReady(true);
      }
    });

    return () => unsub();
  }, []);

  if (!ready) return null; // could render a spinner if you prefer
  return children;
}
